import * as React from 'react'
import '../App.css'
import { Button } from '@mui/material';
import logo from '../assets/logo.png'
import { Link } from 'react-router-dom';
import CustomText from '../utilities/CustomDiv';
import { UserProfile } from '../contexts/UserContext';

const Menu = (props) => {
    const [userData, setUserData] = React.useContext(UserProfile)

    const Title = (props) => {
        return(
            <CustomText style={styles.box}>
                {props.title}
            </CustomText>
        )
    }

    return(
        <div style={{width: 220, height: 930, alignItems: 'center'}}>

            <Title title='Início' />
                <div style={{display: 'flex', flexDirection: 'column', paddingBottom: 10}}>
                    <Button style={styles.link} component={Link} to="/dashboard">Dashboard</Button>
                </div>
            
            <Title title='Inspeções' />
                <div style={{display: 'flex', flexDirection: 'column', paddingBottom: 10}}>
                    {userData.role === 'cliente' || userData.role === 'clienteAdm' ? <></> :
                        <Button style={styles.link} component={Link} to="/criar-inspecao">Criar nova inspeção</Button>
                    }
                    <Button style={styles.link} component={Link} to="/inspecoes-em-aberto">Inspeções em aberto</Button>
                    <Button style={styles.link} component={Link} to="/buscar-inspecao">Buscar inspeção por ID</Button>
                    <Button style={styles.link} component={Link} to="/historico-de-inspecoes">Histórico de inspeções</Button>
                </div>

            
            {userData.role === 'cliente' || userData.role === 'clienteAdm' ? <></> :
                <>
                <Title title='Normas Regulamentadoras' />
                    <div style={{display: 'flex', flexDirection: 'column', paddingBottom: 10}}>
                        <Button style={styles.link} component={Link} to="/listar-nr">Listar NRs</Button>
                        <Button style={styles.link} component={Link} to="/adicionar-nr">Criar NR</Button>
                    </div>
                </>
            }

            <Title title='Usuários' />
                <div style={{display: 'flex', flexDirection: 'column', paddingBottom: 10}}>
                    <Button style={styles.link} component={Link} to="/listar-usuarios">Listar usuários</Button>
                    <Button style={styles.link} component={Link} to="/adicionar-usuarios">Adicionar usuário</Button>
                </div>
            {userData.role === 'cliente' || userData.role === 'clienteAdm' ? <></> :
                <>
                <Title title='Empresas' />
                    <div style={{display: 'flex', flexDirection: 'column', paddingBottom: 10}}>
                        <Button style={styles.link} component={Link} to="/listar-empresas">Listar empresas</Button>
                        <Button style={styles.link} component={Link} to="/adicionar-empresas">Adicionar empresa</Button>
                    </div>
                </>
            }
{/*                
            <Title title='Administradores' />
                <div style={{display: 'flex', flexDirection: 'column', paddingBottom: 10}}>
                    <Button style={styles.link} component={Link} to="/listar-administradores">Listar administradores</Button>
                    <Button style={styles.link} component={Link} to="/criar-admin">Adicionar admin</Button>
                </div>
*/}            
        </div>
    )
}

export default Menu

const styles = {
    box: {
        color: '#ffffff',
        fontSize: 14,
        fontWeight: 600,
        backgroundColor: '#314450',
        padding: 13,
        marginBottom: 10,
        fontFamily: 'Poppins'
    },
    link: {
        color: '#a37272',
        fontFamily: 'Poppins',
        fontSize: 13,
        fontWeight: 400,
        padding: 6,
        textAlign: 'right',
        backgroundColor: 'transparent',
        border: 'none',
        paddingRight: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        textTransform: 'lowercase'
    }
}